import { DeleteOutline } from '@mui/icons-material';
import { lazy, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@ifs-gcp/components';

import { useAuditStore } from '@/store/auditStore';

const LazyDeleteAuditModal = lazy(() => import('./delete-audit-modal/delete-audit-modal'));

type DeleteAuditActionProps = {
  auditCaseUuid: string;
};

export const DeleteAuditAction = ({ auditCaseUuid }: DeleteAuditActionProps) => {
  const { t } = useTranslation();
  const [isDeleteAuditModalOpen, setIsDeleteAuditModalOpen] = useState(false);
  const isActionPending = useAuditStore((state) => state.isActionPending);

  const handleOpenDeleteSelfAssessment = () => {
    setIsDeleteAuditModalOpen(true);
  };

  const handleCloseDeleteSelfAssessment = () => {
    setIsDeleteAuditModalOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        startIcon={<DeleteOutline />}
        onClick={handleOpenDeleteSelfAssessment}
        disabled={isActionPending}
      >
        {t('actions.delete')}
      </Button>

      {isDeleteAuditModalOpen && (
        <LazyDeleteAuditModal
          auditCaseUuid={auditCaseUuid}
          onClose={handleCloseDeleteSelfAssessment}
        />
      )}
    </>
  );
};
